module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/dishes-0148bdd3bb1ddaaec8fd7c15139606a9.svg";